import PropTypes from 'prop-types';

import { useTopicCardContext } from 'hb-react/shared/apps/TopicsIndexV2/contexts/TopicCardContext';
import { TopicMemberRequestProvider } from 'hb-react/shared/apps/TopicsIndexV2/contexts/TopicMemberRequestContext';
import useTopicMemberRequest from 'hb-react/shared/apps/TopicsIndexV2/hooks/useTopicMemberRequest';

import MemberRequestModal from './MemberRequestModal';

const TopicMemberRequest = ({ setIsMember }) => {
  const {
    handleCancel,
    handleEdit,
    handleSubmitRequest,
    isCanceling,
    isEditing,
    isLoading,
    isRequestModalOpen,
    isSubmitting,
    requestApproval,
  } = useTopicMemberRequest(setIsMember);

  const { topic, forceDefaultLink, href, setDisplayRequestModal, target } =
    useTopicCardContext();

  return (
    <TopicMemberRequestProvider
      handleCancel={handleCancel}
      handleEdit={handleEdit}
      handleSubmitRequest={handleSubmitRequest}
      isCanceling={isCanceling}
      isEditing={isEditing}
      isLoading={isLoading}
      isRequestModalOpen={isRequestModalOpen}
      isSubmitting={isSubmitting}
      requestApproval={requestApproval}
    >
      <MemberRequestModal
        forceDefaultLink={forceDefaultLink}
        handleCancel={handleCancel}
        handleEdit={handleEdit}
        handleSubmitRequest={handleSubmitRequest}
        href={href}
        isCanceling={isCanceling}
        isEditing={isEditing}
        isLoading={isLoading}
        isRequestModalOpen={isRequestModalOpen}
        isSubmitting={isSubmitting}
        requestApproval={requestApproval}
        setDisplayRequestModal={setDisplayRequestModal}
        target={target}
        topic={topic}
      />
    </TopicMemberRequestProvider>
  );
};

export default TopicMemberRequest;

TopicMemberRequest.protoTypes = {
  setIsMember: PropTypes.func.isRequired,
};
